/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TipoOrganizzazioneResDto } from '../../models/tipo-organizzazione-res-dto';

export interface TipiOrganizzazioniControllerFindManyTipoOrganiazione$Params {}

export function tipiOrganizzazioniControllerFindManyTipoOrganiazione(
  http: HttpClient,
  rootUrl: string,
  params?: TipiOrganizzazioniControllerFindManyTipoOrganiazione$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<TipoOrganizzazioneResDto>>> {
  const rb = new RequestBuilder(
    rootUrl,
    tipiOrganizzazioniControllerFindManyTipoOrganiazione.PATH,
    'get',
  );
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TipoOrganizzazioneResDto>>;
      }),
    );
}

tipiOrganizzazioniControllerFindManyTipoOrganiazione.PATH =
  '/tipiOrganizzazioni';
